import { graphql } from 'gql';

export const getWorkOrderOther = graphql(`
    query uerWorkOrderOther($workOrderId: Long!, $constructionTypeId: Int!, $chapter: ChapterEnum!) {
        uerWorkOrderOther(workOrderId: $workOrderId, constructionTypeId: $constructionTypeId, chapter: $chapter) {
            contractOtherCostId
            name
            calculatingType
            calculatingTypeValue
            chapter
            section
            limits {
                season {
                    id
                    year
                }
                costLimit
                totalRemainderCost
            }
            status
        }
    }
`);

export const addWorkOrderOtherCost = graphql(`
    mutation uerAddWorkOrderOtherCost($workOrderId: Long!, $otherCostInput: UpdateWorkOrderOtherCostInput!) {
        uerAddWorkOrderOtherCost(workOrderId: $workOrderId, otherCostInput: $otherCostInput) {
            data {
                id
                name
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const workOrderOthersForActKC2 = graphql(`
    query uerWorkOrderOthersForActKC2($workOrderObjectId: Long!) {
        uerWorkOrderOthersForActKC2(workOrderObjectId: $workOrderObjectId) {
            hasSeasonLimit
            contractOtherCostId
            name
            calculatingType
            calculatingTypeValue
            chapter
            section
            status
            limits {
                season {
                    year
                    id
                }
                costLimit
                totalRemainderCost
                deviation
            }
        }
    }
`);

export const addOtherToActKC2 = graphql(`
    mutation uerAddOtherCostToActKC2($workOrderObjectId: Long!, $otherInputs: [UerOtherCostInput!]!) {
        uerAddOtherCostToActKC2(otherInputs: $otherInputs, workOrderObjectId: $workOrderObjectId) {
            data
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
            message
        }
    }
`);
